import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './index.css';
import './Refactor/styles/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { StateProvider } from './Refactor/state/StateProvider';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <StateProvider>
    <App />
    </StateProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.unregister();
navigator.serviceWorker.getRegistration().then((registration: any) => {
  if (registration) {
    registration.addEventListener('updatefound', () => {
      console.log("[ADPClient][serviceWorker] Service Worker update found!");
      registration.waiting.postMessage({type: 'SKIP_WAITING'});
      window.location.reload();
    });
  }
});
const config = {
  onSuccess : ()=>{
    console.log("[ADPClient][serviceWorker] Service Worker Loaded")
  },
  onUpdate:()=>{
    console.log("[ADPClient][serviceWorker] Update Found,notify client");
    window.location.reload();
  }
}
serviceWorkerRegistration.register(config);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.debug);
